import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

const TiedParcelSchema_ = z.object({
  /** The OMS parcel's Mongo ObjectId, hex-encoded to match getParcels. */
  parcelOid: z.string(),
  suppliesProductId: productIdFormat.schema,
});
export const TiedParcelSchema: z.ZodType<TiedParcel> = TiedParcelSchema_;
export interface TiedParcel extends z.infer<typeof TiedParcelSchema_> {}

export const getSuppliesTiedParcels = {
  name: "getSuppliesTiedParcels" as const,
  input: z.object({}),
  output: z.object({ ties: z.array(TiedParcelSchema) }),
};
